import { VehicleLocation } from 'server'
import { useFeathersClient } from '@strac/react-client-feathers'
import { useQuery } from '@tanstack/react-query'
import useVehicleLocationListener from './useVehicleLocationListener'

const useVehicleLocation = (vehicleId: number): VehicleLocation | undefined => {

  const client = useFeathersClient()

  const { data: vehicleLocation } = useQuery({
    queryKey: ['vehicle-location', 'find', vehicleId],
    queryFn: () =>
      client.service('vehicle-location').find({
        query: {
          vehicle_id: vehicleId
        }
      }).then((res: any) => res.data[0]),
    enabled: !!vehicleId,
    refetchInterval: 30000
  })

  const updatedVehicleLocation = useVehicleLocationListener(vehicleId)

  return updatedVehicleLocation || vehicleLocation
}

export default useVehicleLocation
